export const MENU_RECEIVED = "MENU_RECEIVED";
export const MENU_RESET = "MENU_RESET";
